import React from 'react';
import { ClockCircleOutlined, MailOutlined, SendOutlined } from '@ant-design/icons';
import './Statistics.scss';

const healthLabels = { outbox_due: '待处理邮件', outbox_active_leases: '发送中任务', sync_stale_queued: '同步邮件排队超时', sync_stale_sending: '同步邮件发送超时', sync_delivery_unknown: '投递结果未知' };
const mailLabels = { queued: '排队中', sending: '发送中', sent: '已发送', failed: '失败', cancelled: '已取消', retry: '待重试', delivered: '已投递', delivery_unknown: '投递未知' };
const modeLabels = { sync: '同步发送', outbox: '后台发送' };
const formatCount = value => typeof value === 'number' ? value.toLocaleString('zh-CN') : value ?? '暂无';

const MailStatistics = ({ data }) => {
  const jobs = Object.entries(data.mail_jobs || {});
  const modes = Object.entries(data.mail_jobs_by_mode || {});
  const health = Object.entries(data.mail_health || {});
  const updatedAt = new Date(data.generated_at);

  return <section className="featurePage-panel mailStatistics" aria-labelledby="mailStatistics-title">
    <div className="mailStatistics-heading">
      <div className="mailStatistics-title">
        <span className="mailStatistics-icon"><MailOutlined /></span>
        <h2 id="mailStatistics-title">邮件任务</h2>
      </div>
      {!Number.isNaN(updatedAt.getTime()) && <time className="mailStatistics-updated" dateTime={updatedAt.toISOString()}>更新时间：{updatedAt.toLocaleString('zh-CN')}</time>}
    </div>

    <div className="mailStatistics-content">
    {jobs.length ? <dl className="mailStatistics-overview">
      {jobs.map(([status, count]) => <div className="mailStatistics-stat" key={status}>
        <dt><span className={`mailStatistics-dot is-${status}`} />{mailLabels[status] || status}</dt>
        <dd>{formatCount(count)}<span>个任务</span></dd>
      </div>)}
    </dl> : <p className="mailStatistics-empty">暂无邮件任务</p>}

    {modes.length > 0 && <div className="mailStatistics-modes">
      {modes.map(([mode, states]) => <section className="mailStatistics-mode" key={mode} aria-label={modeLabels[mode] || mode}>
        <h3>{mode === 'sync' ? <SendOutlined /> : <ClockCircleOutlined />}{modeLabels[mode] || mode}</h3>
        {Object.keys(states || {}).length ? <dl className="mailStatistics-mode-counts">
          {Object.entries(states).map(([status, count]) => <div key={status}>
            <dt><span className={`mailStatistics-dot is-${status}`} />{mailLabels[status] || status}</dt><dd>{formatCount(count)}</dd>
          </div>)}
        </dl> : <p className="mailStatistics-empty">暂无任务</p>}
      </section>)}
    </div>}
    </div>

    <div className="mailStatistics-health">
      <h3>投递状况</h3>
      {health.length ? <dl className="mailStatistics-health-counts">
        {health.map(([key, count]) => <div key={key}><dt>{healthLabels[key] || key}</dt><dd>{formatCount(count)}</dd></div>)}
      </dl> : <p className="mailStatistics-empty">暂无投递数据</p>}
    </div>
  </section>;
};

export default MailStatistics;
